export default () => {
  const userAgent = navigator.userAgent;
  const url = window.location.pathname + window.location.search;

  if (/SamsungBrowser\//i.test(userAgent) && url) {
    const path = url.replace(/^\/+/g, '');
    const fallbackUrl = encodeURIComponent(window.location.href);
    const intentUrl = `intent://${path}/#Intent;scheme=ro;package=nl.reformatorischeomroep;S.browser_fallback_url=${fallbackUrl};end`;

    try {
      window.location.href = intentUrl;
    } catch (e) {
      // If the intent fails, redirect to the fallback URL
      console.error('Intent redirect failed', e);
    }
  }
};
